import { ReactElement, ReactNode } from 'react';
import { useFetchTaskInfo } from '../../queries';
import { TaskInfoContext } from './context';

type TaskInfoProviderProps = {
    readonly taskId: string;
    readonly children?: ReactNode;
};
export function TaskInfoProvider(props: TaskInfoProviderProps): ReactElement {
    const { taskId, children } = props;

    const { taskInfo, status, refetch } = useFetchTaskInfo(taskId);

    return (
        <TaskInfoContext.Provider
            value={{
                taskInfo: taskInfo ?? null,
                status,
                refetch
            }}
        >
            {children}
        </TaskInfoContext.Provider>
    );
}
